import { CabinetWrapper } from '@/shared/cabinet-wrapper';
import ComponentWithLoader from '@/shared/ComponentWithLoader/ComponentWithLoader';
import { FactoringAgreements } from '@/shared/factoring-agreements';
import { FactoringBranches } from '@/shared/factoring-branches';
import { FactoringEmployees } from '@/shared/factoring-employees';
import { PageTitle } from '@/shared/page-title';
import UITabs from '@/shared/ui/ui-tabs';
import { SyntheticEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useAppSelector } from '@/app/hooks';
import { checkRole } from '@/app/helpers';

export const FactorSettingsPage = () => {
  const { t } = useTranslation();
  const { profile } = useAppSelector((state) => state.auth);
  const { isAdmin } = checkRole(profile?.roles);

  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(
    Number(searchParams.get('activeTab')) || 0
  );

  useEffect(() => {
    setActiveTab(Number(searchParams.get('activeTab')) || 0);
  }, [searchParams]);

  const handleTabChange = (
    _event: SyntheticEvent<Element, Event>,
    newValue: number
  ) => {
    setActiveTab(newValue);
    setSearchParams({ activeTab: newValue.toString() });
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <FactoringAgreements />;
      case 1:
        return <FactoringBranches />;
      case 2:
        return <FactoringEmployees />;
      default:
        return <FactoringAgreements />;
    }
  };

  const tabs = [
    t('settings.tabs.1'),
    t('settings.tabs.2'),
    ...(isAdmin ? [t('settings.tabs.3')] : []),
  ];

  return (
    <CabinetWrapper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        pb: 0,
      }}
    >
      <ComponentWithLoader isLoading={false}>
        <PageTitle title={t('settings.title')} noBack />

        <UITabs
          value={activeTab}
          onChange={handleTabChange}
          tabs={tabs.map((tab) => ({
            label: tab,
            component: renderTabContent(),
          }))}
        />
      </ComponentWithLoader>
    </CabinetWrapper>
  );
};
